import axios from "axios";
import authHeader from "../services/auth_header";
import { BASE } from "./config";
import { getSessionId, getTransactionId, logUserAction } from "../../utility/commonFunctions";

export default (history = null) => {
  const baseURL = BASE + "/api/chef/private";
  let headers = {};
  const auth = authHeader();
  if (auth) {
    headers.Authorization = auth.authorization;
  }

  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers,
  });

  // Request Interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      config.headers["x-session-id"] = getSessionId();
      config.headers["x-transaction-id"] = getTransactionId();
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response Interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      logUserAction("API_RESPONSE", {
        url: response.config.url,
        status: response.status,
        sessionId: getSessionId(),
        transactionId: response.config.headers["transactionId"],
      });
      return Promise.resolve(response);
    },
    (error) => {
      logUserAction("API_ERROR", {
        url: error.config?.url,
        status: error.response?.status,
        sessionId: getSessionId(),
        transactionId: error.config?.headers?.["transactionId"],
        
      });

      if (!error.response) {
        return Promise.reject(error);
      }


      if (error.response.status === 404) {
        localStorage.clear();

        if (history) {
          history.push("/");
        } else {
          window.location = "/";
        }
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};
